module.exports = __webpack_public_path__ + "img/message_active.a8f5dc1e.svg";